import { useAuthStore } from '@/stores/auth'
export default {

    mounted(el, binding, vnode) {
        const auth = useAuthStore()
        const permission = binding.value
        //const { res,perm} = binding.value


//console.log("el, binding, vnode",el, binding, vnode)

        const block = (event) => {
            if (!auth.can(permission)) {          
            event?.preventDefault?.()
            event?.stopImmediatePropagation?.()
            return false
            }
        }

        // DOM click
        el.__vCanDomHandler__ = block
        el.addEventListener('click', block, true)

        // Vue component click (важливо для el-dropdown-item)
        if (vnode.component) {
            const original = vnode.component.props.onClick
            vnode.component.props.onClick = (...args) => {
                if (block(args[0]) === false) return
                original?.(...args)
            }
        }
    },
    unmounted(el) {
        el.removeEventListener('click', el.__vCanDomHandler__)
        delete el.__vCanDomHandler__
    }
}
